// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Sprint 47.4.4 — Immutable Audit Trails credit-package pricing card.
 *
 * Source of truth for the 3 v1 SKUs surfaced via the AesirX Proof
 * Service API (`docs/engineering/aesirx-proof-service-api.md` §6) and
 * the architecture doc (`docs/engineering/immutable-audit-trails.md`
 * §10.2). Server-side validation (`credit-service.redeemCreditPackage`)
 * rejects any redeem whose `(package, units, price_paid_usd)` tuple
 * does not match this table to the cent.
 *
 * Currency is USD only in v1; non-USD ladders are out of scope.
 */
export const IAT_CREDIT_PACKAGES = {
    starter: { units: 10_000, price_usd: 150.0 },
    growth: { units: 100_000, price_usd: 1_400.0 },
    enterprise: { units: 1_000_000, price_usd: 12_500.0 },
};
/** All package codes as a readonly array (UI dropdowns / validators). */
export const IAT_CREDIT_PACKAGE_CODES = [
    'starter',
    'growth',
    'enterprise',
];
//# sourceMappingURL=iat-pricing.js.map